import { Box } from "@mui/material"

const UberLogo = (props) => (
    <Box
        component="svg"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 52 20"
        role="img"
        aria-label="Uber"
        {...props}
    >
        <text
            x="0"
            y="16"
            fill="#000435"
            fontFamily="'DM Sans', system-ui, sans-serif"
            fontSize="18"
            fontWeight="500"
            letterSpacing="-0.04em"
        >
            Uber
        </text>
    </Box>
)

const BoltLogo = (props) => (
    <Box
        component="svg"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 20"
        role="img"
        aria-label="Bolt"
        {...props}
    >
        <text
            x="0"
            y="16"
            fill="#34D186"
            fontFamily="'DM Sans', system-ui, sans-serif"
            fontSize="18"
            fontWeight="700"
            letterSpacing="-0.02em"
        >
            Bolt
        </text>
    </Box>
)

export { UberLogo, BoltLogo }
